import * as React from 'react';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import {
  getAllProgramsAsync,
  updateProgramAsync,
} from './ProgramStore/programStoreSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const UpdateProgram = ({ programData, handleClose }) => {
  const [programName, setProgramName] = React.useState(programData.name);
  const [programDescription, setProgramDescription] = React.useState(
    programData.description
  );
  const [programSlug, setProgramSlug] = React.useState(programData.slug);
  console.log({ programData });

  React.useEffect(() => {
    if (
      programData &&
      programData._id &&
      programData.name &&
      programData.description &&
      programData.slug
    ) {
      setProgramName(programData.name);
      setProgramDescription(programData.description);
      setProgramSlug(programData.slug);
    }
  }, [programData]);

  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const fetchAllPrograms = async () => {
    try {
      dispatch(getAllProgramsAsync());
    } catch (error) {
      console.log(error);
    }
  };

  const updateProgram = async () => {
    try {
      handleLoader(true);
      dispatch(
        updateProgramAsync({
          id: programData._id,
          bodyData: {
            name: programName.trim(),
            description: programDescription.trim(),
            slug: programSlug.trim(),
          },
        })
      )
        .unwrap()
        .then((res) => {
          if (res) {
            SuccessToast(`Course updated successfully.`);
            fetchAllPrograms();
            handleLoader(false);
            handleClose();
          } else {
            handleLoader(false);
          }
        });
    } catch (error) {
      console.log(error);
      handleLoader(false);
      ErrorToast('Course could not be added. Please try again!');
    }
  };

  return (
    <Box sx={style}>
      <Box>
        <Typography>Update a Course</Typography>
        <Box my={2}>
          <BuzzInput
            type="text"
            name="email"
            required
            placeholder="Program name"
            label="Program Name"
            value={programName}
            onChange={(e) => setProgramName(e.target.value)}
          />
        </Box>
        <Box my={2}>
          <BuzzInput
            type="text"
            name="slug"
            required
            placeholder="Program slug"
            label="Program Slug"
            value={programSlug}
            onChange={(e) => setProgramSlug(e.target.value)}
          />
        </Box>
        <Box my={2} width="100%">
          <Box mb={1}>
            Program Description <span style={{ color: 'red' }}>*</span>
          </Box>
          <TextField
            variant="outlined"
            multiline
            rows={6}
            rowsMax={6}
            value={programDescription}
            onChange={(e) => setProgramDescription(e.target.value)}
            size="small"
            fullWidth
          />
        </Box>
        <Box my={2}>
          <Button variant="contained" color="primary" onClick={updateProgram}>
            Update Course
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default UpdateProgram;
